import type { CSSProperties } from 'react'
import { Toaster as Sonner, type ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--color-primary-500)',
          '--normal-text': 'var(--color-primary-foreground)',
          '--normal-border': 'var(--color-primary-600)',
        } as CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
